module.exports = __webpack_public_path__ + "static/media/image (58).3a01cd68.jpg";